import { Component, OnInit, Input } from '@angular/core';

import { Attachment } from '../../../models/attachment';

import { TeamnoteConfigService } from '../../../configs/teamnote-config.service';
import { AudioPlayerService } from '../../audio-player/audio-player.service';
import { FileFactoryService } from '../../file-factory/file-factory.service';
import { ModuleManagerService } from '../../../webclient/services/module/module-manager.service';
import { ModuleKeyDefinition } from '../../../constants/module.constant';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { WebclientService } from '../../../webclient/webclient.service';

@Component({
  selector: 'tn-attachment-audio',
  templateUrl: './attachment-audio.component.html',
  styleUrls: ['./attachment-audio.component.scss']
})
export class AttachmentAudioComponent implements OnInit {
  @Input() attachment: Attachment;
  @Input() attachmentId: string;
  @Input() filename: string;
  @Input() isDisableDownload: boolean = false;
  @Input() isChatMessage: boolean = false;

  audioUrl: any;
  mimeType: string = "audio/mpeg";

  isAllowAttachmentSave: boolean = false;

  constructor(
    private _teamnoteConfigService: TeamnoteConfigService,
    private _audioPlayerService: AudioPlayerService,
    private _fileFactoryService: FileFactoryService,
    private _moduleManagerService: ModuleManagerService,
    private _fileManagerService: FileManagerService,
    private _webclientService: WebclientService,
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (!this.attachmentId) {
      return;
    }

    if (this.isChatMessage) {
      this.isAllowAttachmentSave = this._moduleManagerService.checkIfModuleExists(ModuleKeyDefinition.ATTACHMENT_SAVE) || this._moduleManagerService.checkIfModuleExists(ModuleKeyDefinition.ATTACHMENT_SAVE_WEB);

      //Always allow attachment download
      if (this._teamnoteConfigService.config.WEBCLIENT.CHATROOM.IS_ALWAYS_ALLOW_DOWNLOAD){
        this.isAllowAttachmentSave = true;
      }

      if (this._webclientService.allow_download_secure_message_webclient){
        this.isDisableDownload = false;
      }
    }

    if (this._teamnoteConfigService.isBrowserIE || this._teamnoteConfigService.isBrowserFirefox) {
      this._audioPlayerService.convertAudioToMp3(
        this.attachmentId,
        (dataUrl) => {
          this.audioUrl = dataUrl;
          this.mimeType = "audio/mp3";
        }
      );
    } else {
      this._fileFactoryService.getFileByAttachmentId(
        this.attachmentId,
        (dataUrl) => {
          this.audioUrl = dataUrl;
        },
        (err) => {},
        false
      );
    }
  }

  downloadFile(): void {
    if (this.attachmentId.includes('blob:http')) {
      const link = document.createElement('a');
      link.download = this.filename;
      link.href = this.attachmentId;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }else {
      this._fileManagerService.downloadFileByAttachmentId(
        this.attachmentId, this.attachment ? this.attachment.filename : this.attachmentId);
    }
  }
}

